import { showModal } from 'react-redux-modal-provider';
import DialogTitleDefault from '../default/DialogTitleDefault';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import { ButtonBasic } from '../../components';
import { Box, Card, Divider, Grid, Typography } from '@mui/material';
import { useMemo } from 'react';
import ModalCrearTicketNubicomMasivos from './ModalCrearTicketNubicomMasivos';
import ModalCrearTicketNubicomV2 from './ModalCrearTicketNubicomV2';

function ModalNewTickets({show, hideModal,onGuardar,permisos}) {

    const handleClose = () => hideModal();
    const onClickTicketNubi = () => {
        showModal(ModalCrearTicketNubicomV2, { onGuardar: onGuardar });
        hideModal()
    }
    const onClickTicketNubiMasivo = () => {
        showModal(ModalCrearTicketNubicomMasivos, { onGuardar: onGuardar });
        hideModal()
    }
    const styleBtn = useMemo(() => ({
        mt:5,
        border:2,
        borderRadius:5,
        borderColor: '#0364ff',
        color: '#0364ff',
        fontWeight: 'bold',
        width: 180,
        '&:hover':{
            color: '#0364ff',
            background: '#e6f0ff'
        }
    }), [])
    const styleBtn2 = useMemo(() => ({
        mt:1,
        border:2,
        borderRadius:5,
        borderColor: '#0364ff',
        color: '#0364ff',
        fontWeight: 'bold',
        width: 180,
        '&:hover':{
            color: '#0364ff',
            background: '#e6f0ff'
        }
    }), [])
    const styleCard = useMemo(() => ({
        background: '#fff !important',
        display: 'flex',
        justifyContent:'center',
        alignItems:'center',
        flexDirection: 'column',
        p:3,
        boxShadow:0,
        border:1,
        borderColor: 'gray',
        borderRadius:3,
        minHeight: 270,
        width: 250,
        '&:hover':{
            boxShadow: 6
        }
    }), [])
    return (
        <Dialog open={show} disableEscapeKeyDown maxWidth='xs' fullWidth className='side'>
            <Box sx={{background: '#fff'}} className='side'>
                <DialogTitleDefault id="add-canal-priv" onClose={handleClose}>
                    <Typography sx={{flex:1,textAlign: 'center', color: '#000',fontWeight: 'bold'}} variant='h5'>
                    Nuevo Ticket
                    </Typography>
                </DialogTitleDefault>
                <Divider sx={{background: 'gray'}} />
                <DialogContent className='side'>
                    <Grid container>
                        <Grid item xs={12} p={1} display='flex' justifyContent='center' alignItems='center'>
                            <Card sx={styleCard}>
                                <img src='/img/nubicom.png' style={{width: 160,height: 55,marginTop:47}} />
                                <ButtonBasic
                                    textButton='Clientes Nubicom'
                                    color='blanco'
                                    variant='wk'
                                    sx={styleBtn}
                                    onClick={()=>onClickTicketNubi()}
                                />
                                <ButtonBasic
                                    textButton='Tickets Masivos'
                                    color='blanco'
                                    variant='wk'
                                    sx={styleBtn2}
                                    onClick={()=>onClickTicketNubiMasivo()}
                                />
                            </Card>
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions sx={{display:'flex', justifyContent:'center'}}>
                    <ButtonBasic
                        sx={{width: '80%',mb:1}}
                        textButton='Cancelar'
                        variant='wk'
                        color='cancel'
                        onClick={()=>handleClose()}
                    />
                </DialogActions>
            </Box>
        </Dialog>
    );
}
export default ModalNewTickets;